import Vue from 'vue';
import appconst from './appconst'
import {Modal} from 'ant-design-vue';
import _ from 'lodash';
import tools from '@/lib/tools'
import moment from 'moment';
import app from "@/app.vue";

type confirmParamCallBack = () => void;

interface confirmParam {
    /**窗口标题 */
    title?: string;
    /**窗口内容 */
    content?: string;
    /**点击确定时回调 */
    onOk?: confirmParamCallBack;
    /**其他参数 */
    extraParam?: Object
}

interface TreeNodeData {
    /**
     * 主键
     */
    key?: string;
    /**
     * 标题
     */
    title?: string;
    /**
     * 值
     */
    value?: string;
    /**
     * 说明
     */
    sm?: string;
}

class Util {
    abp: any = window.abp;

    loadScript(url: string) {
        var script = document.createElement('script');
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
    }

    title(title: string) {
        // let appname = this.abp.localization.localize('玉溪市智慧“三湖”', appconst.localization.defaultLocalizationSourceName);
        // let page = this.abp.localization.localize(title, appconst.localization.defaultLocalizationSourceName);
        // window.document.title = appname;
    }

    inOf(arr: Array<any>, targetArr: any) {
        let res = true;
        arr.forEach(item => {
            if (targetArr.indexOf(item) < 0) {
                res = false;
            }
        });
        return res;
    }

    oneOf(ele: any, targetArr: Array<any>) {
        if (targetArr.indexOf(ele) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    showThisRoute(itAccess: any, currentAccess: any) {
        if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
            return this.oneOf(currentAccess, itAccess);
        } else {
            return itAccess === currentAccess;
        }
    }

    getRouterObjByName(routers: Array<any>, name?: string): any {
        if (!name || !routers || !routers.length) {
            return null;
        }
        // debugger;
        let routerObj = null;
        for (let item of routers) {
            if (item.name === name) {
                return item;
            }
            routerObj = this.getRouterObjByName(item.children, name);
            if (routerObj) {
                return routerObj;
            }
        }
        return null;
    }

    toDefaultPage(routers: Array<any>, name: string | undefined, route: any, next: any) {
        let len = routers.length;
        let i = 0;
        let notHandle = true;
        while (i < len) {
            if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
                route.replace({
                    name: routers[i].children[0].name
                });
                notHandle = false;
                next();
                break;
            }
            i++;
        }
        if (notHandle) {
            next();
        }
    }

    handleTitle(vm: any, item: any) {
        if (typeof item.meta.title === 'object') {
            return vm.$t(item.title.i18n);
        } else {
            return item.meta.title;
        }
    }

    setCurrentPath(vm: Vue, name?: string) {
        let title = '';
        let isOtherRouter = false;
        vm.$store.state.app.routers.forEach((item: any) => {
            if (item.children.length === 1) {
                if (item.children[0].name === name) {
                    title = this.handleTitle(vm, item);
                    if (item.name === 'otherRouter') {
                        isOtherRouter = true;
                    }
                }
            } else {
                item.children.forEach((child: any) => {
                    if (child.name === name) {
                        title = this.handleTitle(vm, child);
                        if (item.name === 'otherRouter') {
                            isOtherRouter = true;
                        }
                    }
                });
            }
        });
        let currentPathArr = [];
        if (name === 'home') {
            currentPathArr = [
                {
                    meta: {title: this.handleTitle(vm, this.getRouterObjByName(vm.$store.state.app.routers, 'home'))},
                    path: 'main/home',
                    name: 'home'
                }
            ];
        } else if (((name as string).indexOf('index') >= 0 || isOtherRouter) && name !== 'home') {
            currentPathArr = [
                {
                    meta: {title: this.handleTitle(vm, this.getRouterObjByName(vm.$store.state.app.routers, 'home'))},
                    path: 'main/home',
                    name: 'home'
                },
                {
                    meta: {title: title},
                    path: '',
                    name: name
                }
            ];
        } else {
            let currentPathObj = vm.$store.state.app.routers.filter((item: any) => {
                if (item.children.length <= 1) {
                    return item.children[0].name === name || item.name === name;
                } else {
                    let i = 0;
                    let childArr = item.children;
                    let len = childArr.length;
                    while (i < len) {
                        if (childArr[i].name === name) {
                            return true;
                        }
                        i++;
                    }
                    return false;
                }
            })[0];
            if (currentPathObj.children && currentPathObj.children.length <= 1 && currentPathObj.name === 'home') {
                currentPathArr = [
                    {
                        meta: {title: 'HomePage'},
                        path: 'main/home',
                        name: 'home'
                    }
                ];
            } else if (currentPathObj.children && currentPathObj.children.length <= 1 && currentPathObj.name !== 'home') {
                currentPathArr = [
                    {
                        meta: {title: 'HomePage'},
                        path: 'main/home',
                        name: 'home'
                    },
                    {
                        meta: {title: currentPathObj.meta.title},
                        path: '',
                        name: name
                    }
                ];
            } else {
                let childObj = currentPathObj.children.filter((child: any) => {
                    return child.name === name;
                })[0];
                currentPathArr = [
                    {
                        meta: {title: 'HomePage'},
                        path: 'main/home',
                        name: 'home'
                    },
                    {
                        meta: {title: currentPathObj.meta.title},
                        path: '',
                        name: ''
                    },
                    {
                        meta: {title: childObj.meta.title},
                        path: currentPathObj.path + '/' + childObj.path,
                        name: name
                    }
                ];
            }
        }
        vm.$store.commit('app/setCurrentPath', currentPathArr);

        return currentPathArr;
    }

    openNewPage(vm: Vue, name: string | undefined, argu?: any, query?: any) {
        let pageOpenedList = vm.$store.state.app.pageOpenedList;
        let openedPageLen = pageOpenedList.length;
        let i = 0;
        let tagHasOpened = false;
        while (i < openedPageLen) {
            if (name === pageOpenedList[i].name) { // 页面已经打开
                vm.$store.commit('app/pageOpenedList', {
                    index: i,
                    argu: argu,
                    query: query
                });
                tagHasOpened = true;
                break;
            }
            i++;
        }
        if (!tagHasOpened) {
            let tag = vm.$store.state.app.tagsList.filter((item: any) => {
                if (item.children) {
                    return name === item.children[0].name;
                } else {
                    return name === item.name;
                }
            });
            tag = tag[0];
            if (tag) {
                tag = tag.children ? tag.children[0] : tag;
                if (argu) {
                    tag.argu = argu;
                }
                if (query) {
                    tag.query = query;
                }
                vm.$store.commit('app/increateTag', tag);
            }
        }
        vm.$store.commit('app/setCurrentPageName', name);
    }

    fullscreenEvent(vm: Vue) {
        vm.$store.commit('app/initCachepage');
        // 权限菜单过滤相关
        vm.$store.commit('app/updateMenulist');
        // 全屏相关
    }

    extend(...args: any[]) {
        let options, name, src, srcType, copy, copyType, copyIsArray, clone,
            target = args[0] || {},
            i = 1,
            length = args.length,
            deep = false;
        if (typeof target === 'boolean') {
            deep = target;
            target = args[i] || {};
            i++;
        }
        if (typeof target !== 'object' && typeof target !== 'function') {
            target = {};
        }
        if (i === length) {
            target = this;
            i--;
        }
        for (; i < length; i++) {
            if ((options = args[i]) !== null) {
                for (name in options) {
                    src = target[name];
                    copy = options[name];
                    if (target === copy) {
                        continue;
                    }
                    srcType = Array.isArray(src) ? 'array' : typeof src;
                    if (deep && copy && ((copyIsArray = Array.isArray(copy)) || typeof copy === 'object')) {
                        if (copyIsArray) {
                            copyIsArray = false;
                            clone = src && srcType === 'array' ? src : [];
                        } else {
                            clone = src && srcType === 'object' ? src : {};
                        }
                        target[name] = this.extend(deep, clone, copy);
                    } else if (copy !== undefined) {
                        target[name] = copy;
                    }
                }
            }
        }
        return target;
    }

    /**
     * 确认弹出框函数
     * @param param 弹出框参数
     */
    confirm(param: confirmParam) {
        var defaultObj = {
            title: "提醒",
            content: "是否确定要提交?",
            onOk: _.noop,
            okText: "确定",
            cancelText: "取消"
        }
        var obj = _.extend(defaultObj, param.extraParam)
        if (!tools.isEmptyStr(param.content)) {
            obj.content = param.content
        }
        if (!tools.isEmptyStr(param.title)) {
            obj.title = param.title
        }
        if (param.onOk != undefined) {
            obj.onOk = param.onOk;
        }
        Modal.confirm(defaultObj);
    }

    /**
     * 保存成功确认弹出框函数
     * @param param 弹出框参数
     */
    success(param: confirmParam) {
        var defaultObj = {
            title: "数据保存成功！",
            okText: "确定",
            destroyOnClose: true,
            autoClose: true,
            autoCloseDelay: 5000,
        }
        var obj = _.extend(defaultObj, param.extraParam)
        if (!tools.isEmptyStr(param.title)) {
            obj.title = param.title
        }
        let mod = Modal.success(defaultObj);
        if (defaultObj.autoClose) {
            setTimeout(() => {
                mod.destroy();
            }, defaultObj.autoCloseDelay)
        }
    }

    info(param: confirmParam) {
        var defaultObj = {
            title: "提示",
            okText: "确定",
            destroyOnClose: true,
            autoClose: true,
            autoCloseDelay: 5000,
        }
        var obj = _.extend(defaultObj, param.extraParam)
        if (!tools.isEmptyStr(param.title)) {
            obj.title = param.title
        }
        let mod = Modal.info(defaultObj);
        if (defaultObj.autoClose) {
            setTimeout(() => {
                mod.destroy();
            }, defaultObj.autoCloseDelay)
        }
    }

    /**
     * 过滤蚂蚁表格数据
     * @param form 蚂蚁表格对象
     * @param data 输入数据
     */
    filterAntFormData(form, data) {
        var formData = form.getFieldsValue();
        var keys = _.keys(formData);
        var ret = {};
        _.each(keys, (val) => {
            if (data[val] !== undefined) {
                ret[val] = data[val]
            }
        })
        return ret
    }

    /**
     * 格式化日期
     * @param date 传入日期
     * @param format 格式化字符串
     */
    formatDate(date, format = "YYYY-MM-DD") {
        return moment(date).format(format);
    }

    /**
     * 格式化日期
     * @param date 传入日期
     * @param format 格式化字符串
     */
    formatDates(date, format = "YYYY-MM-DD HH:mm:ss") {
        return moment(date).format(format);
    }

    /**
     * 判断传入值是不是dom对象
     * @param obj
     */
    isDOM(obj) {
        if (typeof HTMLElement === 'object') {
            return obj instanceof HTMLElement;
        } else {
            return obj && typeof obj === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
        }
    }

    /**
     * 锚点跳转
     * @param selector dom选择器
     */
    anchorJump(selector: any) {
        const anchorEle = this.isDOM(selector) ? selector : document.querySelector(selector);
        if (!!anchorEle) {
            anchorEle.scrollIntoView(true);
        }
    }

    flattenItems(items, key) {
        let self = this
        return _(items).reduce((flattenedItems, item) => {
            flattenedItems.push(item)
            if (Array.isArray(item[key])) {
                flattenedItems = flattenedItems.concat(self.flattenItems(item[key], key))
            }
            return flattenedItems
        }, [])
    }

    /**
     * 获取树节点总数
     * @param data 树形节点数据
     */
    getTreeDataLength(data: Array<TreeNodeData>) {
        return this.flattenItems(data, "children").length;
    }

    /**
     * 打开文件预览窗口
     * @param fileId 文件ID
     * @param bussinessId 业务ID
     */
    openFilePreviewWin(bussinessId: string, fileId: string = "", viewType: string = '1') {
        return window.open("#/attachment/" + viewType + '/' + bussinessId + "/" + fileId);
    }

    /**
     * 给表单赋值
     * @param form ant的表单
     * @param data 传入数据
     */
    setFormValue(form, data) {
        let rData = util.filterAntFormData(form, data);
        var isDateTimePattern = new RegExp(/\d{4}\-(0?[1-9]|[1][012])\-(0?[1-9]|[12][0-9]|3[01])/);
        // _this.form.setFieldsValue(rData);
        _.each(rData, (val: any, key) => {
            if (isDateTimePattern.test(val)) {
                rData[key] = moment(val);
            } else {
                rData[key] = val;
            }
        })
        form.setFieldsValue(rData);
    }

    /**
     * 转换树形数据
     * @param treeDataList 传入树形数据
     */
    transformTreeData(treeDataList) {
        var self = this;
        _.each(treeDataList, (val) => {
            if (val.children == null || val.children.length == 0) {
                val.children = undefined;
            } else {
                self.transformTreeData(val.children);
            }
        })
        return treeDataList;
    }

    /**
     * 生成GUID
     */
    getGuid(hasSplitChar: boolean = false) {
        var tmp = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
        if (!hasSplitChar) {
            tmp = tmp.replace(/-/ig, "");
        }
        return tmp.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    /**
     * 获取树形节点树
     * @param data 树形数据
     * @param treeNodeValue 待查询树形节点值
     * @constructor
     */
    GetTreeNodeMap(data: Array<TreeNodeData>, treeNodeValue) {
        let cData = this.flattenItems(data, "children")
        let valueList = []
        let targetVal = treeNodeValue
        let node = null;
        do {
            if (valueList.length == 0) {
                node = _(cData).find({value: targetVal})
            } else {
                node = _(cData).find(o => {
                    return _.find(o.children, {value: targetVal})
                })
            }
            if (node != null) {
                targetVal = node.value
                valueList.unshift(node.value)
            }
        } while (node != null)
        return valueList
    }

    /**
     * 截取对象中的长字符串
     * @param inputObj 传入对象
     * @param stringLengthLimit 开始截取字符串的长度
     * @constructor
     */
    interceptLongString(inputObj: any, stringLengthLimit: number = 20) {
        _.each(inputObj, (val: any, key) => {
            if (typeof (val) === "string" && val.length > stringLengthLimit) {
                inputObj[key + "sub"] = val.substring(0, stringLengthLimit) + "...";
            } else {
                inputObj[key + "sub"] = val;
            }
        })
        return inputObj;
    }

    /**
     * 转换为蚂蚁上传组件显示用的列表参数
     * @param inputFileList
     */
    getAntUploadFileList(inputFileList, url = "") {
        let ret = []
        if (!inputFileList) {
            return ret;
        }
        _.each(inputFileList, (val, ind) => {
                let temp = {
                    uid: val.id,
                    name: val.filename,
                    status: 'done',
                    url: appconst.apiBaseUrl + "/FileUpload/FileDownLoad?id=" + val.id,
                }
                if (url == "") {
                    temp.url = 'data:application/octet-stream;base64,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';
                }
                ret.push(temp)
            }
        )
        return ret;
    }

    /**
     * rgb颜色转16进制
     * @param color
     */
    colorRGB2Hex(color) {
        var rgb = color.split(',');
        var r = parseInt(rgb[0].split('(')[1]);
        var g = parseInt(rgb[1]);
        var b = parseInt(rgb[2].split(')')[0]);

        var hex = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
        return hex;
    }

    /**
     * 缓存数据
     * @param key key
     * @param value 值
     */
    cacheData(key, value) {
        if (typeof (value) !== 'string') {
            value = JSON.stringify(value);
        }
        localStorage.setItem(key, value);
    }

    /**
     * 获取缓存数据
     * @param key
     *
     */
    getCacheData(key) {
        let tmp = localStorage.getItem(key);
        let ret = JSON.parse(tmp);
        return ret;
    }

    /**
     * 克隆对象,去除代理对象
     * @param obj
     */
    cloneSimple(obj) {
        let dest = JSON.parse(JSON.stringify(_.clone(obj)));
        return dest;
    }


    /**
     * @file: util.ts
     * @method 对象数组去重
     * @param {type} argName - description
     * @param {type} argName - description
     * @param {type} argName - description
     * @return {type} argName - description
     * @description:
     * @author:
     * @date: 2020/2/21
     */
    uniqueArray(arr: Array<any>, key: string) {
        const res = new Map();
        return arr.filter((arr) => !res.has(arr[key]) && res.set(arr[key], 1));
    }

    removeHtml(html: string) {
        if (html) {
            html = html.replace(/&nbsp;/g, ' ')
                .replace(/&amp;/g, '&')
                .replace(/<\/?[^>]*>/g, '')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>').replace(/<(.|\s*|\t|\r|\n)*?>/g, '');
        }
        return html;
    }

    /**
     * @file: util.ts
     * @method getParentKey
     * @param {type}  key - 当前节点key
     * @param {type} tree - 当前tree的数据
     * @return {type} argName - 当前界面的直接父节点
     * @描述: 得到父节点的key
     * @作者: 张俊
     * @日期: 2020/3/19
     */
    getParentKey(key, tree) {
        let parentKey;
        for (let i = 0; i < tree.length; i++) {
            const node = tree[i];
            if (node.children) {
                if (node.children.some(item => item.key === key)) {
                    parentKey = node.key;
                } else if (this.getParentKey(key, node.children)) {
                    parentKey = this.getParentKey(key, node.children);
                }
            }
        }
        return parentKey;
    };


    /***
     * 获取URL中的参数
     * @param paramName 参数名称
     */
    getUrlParam(paramName) {

        //key存在先通过search取值如果取不到就通过hash来取
        let after = window.location.hash.split("?")[1];

        if (after) {

            var reg = new RegExp("(^|&)" + paramName + "=([^&]*)(&|$)");
            var r = after.match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            } else {
                return null;
            }
        }
    }

    //单位换算
    unitConversion(num: number = 0, toUnit?: string, unit?: string, isNotToFix?: boolean): number {
        if (typeof num !== 'number') {
            num = Number(num) || 0;
        }

        const toUnitRate = appconst.rateDic[toUnit] || 1;
        const unitRate = appconst.rateDic[unit] || 1;
        const rate = calculator.divide(unitRate, toUnitRate);
        let result = calculator.times(rate, num);
        return isNotToFix ? result : Number(result.toFixed(2));
    };

    //文件下载方法
    fileDownloadByForm(url, data, method) {
        if (url && data) {
            // data 是 string 或者 array/object
            data = typeof data == 'string' ? data : jQuery.param(data) // 把参数组装成 form的 input
            var inputs = ''
            jQuery.each(data.split('&'), function () {
                var pair = this.split('=')
                inputs += '<input type="hidden" name="' + pair[0] + '" value="' + pair[1] + '" />'
            }) // request发送请求
            let form = jQuery('<form target="_blank" action="' + url + '" method="' + (method || 'post') + '">' + inputs + '</form>').appendTo('body').submit();
            form.remove()
        }
    }

}

const util = new Util();
export default util;


/**
 * @描述：浮点数的计算
 * @作者: 张俊
 * @创建时间: 2020-03-20 13:54:31
 */
class Calculate {
    /**
     * @描述： 兼容多种类型的表示
     * 1.11 或者 1.11e-30 或者 1e-30
     */
    digitLength(num: number): number {
        // 1.11 -> eSplit: ['1.11']
        // 1.11e-30 -> eSplit: ["1.11", "-30"]
        const eSplit = num.toString().split(/[eE]/);
        // 右边的 `|| ''` 为了防止 1e-30 -> eSplit: ["1", "-30"] 这种
        // 左边 1.11 有两个小数，右边 e 后面有 -30，所以是 2 - (-30) 为 32
        const len = (eSplit[0].split('.')[1] || '').length - Number(eSplit[1] || 0);
        return len > 0 ? len : 0;
    }

    /**
     * @描述：baseNum 计算出让 num1、num2 都为整数的最小 10 的倍数
     */
    baseNum(num1: number, num2: number): number {
        return Math.pow(10, Math.max(this.digitLength(num1), this.digitLength(num2)));
    }

    /**
     * @描述：加法
     */
    plus(num1: number, num2: number): number {
        const bn = this.baseNum(num1, num2);
        return (num1 * bn + num2 * bn) / bn;
    }

    /**
     * @描述：减法
     */
    minus(num1: number, num2: number): number {
        const bn = this.baseNum(num1, num2);
        return (num1 * bn - num2 * bn) / bn;
    }

    /**
     * @描述：乘法
     */
    times(num1: number, num2: number): number {
        const bn = this.digitLength(num1) + this.digitLength(num2);
        let intNum1 = num1 * Math.pow(10, this.digitLength(num1));
        intNum1 = Math.ceil(intNum1);
        let intNum2 = num2 * Math.pow(10, this.digitLength(num2));
        intNum2 = Math.ceil(intNum2);
        return (intNum1 * intNum2) / Math.pow(10, bn);
    }

    /**
     * @描述：除法
     */
    divide(num1: number, num2: number): number {
        const bn = this.baseNum(num1, num2);
        let intNum1 = num1 * bn;
        intNum1 = Math.ceil(intNum1);
        let intNum2 = num2 * bn;
        intNum2 = Math.ceil(intNum2);
        return intNum1 / intNum2;
    }
}

const calculator = new Calculate();
export {calculator};
